import Vue from 'vue';
import headroom from 'vue-headroom';

Vue.use(headroom);
